import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Modal,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useTheme } from "@mui/material";
import { tokens } from "../theme";
import axios from "axios";
import Header from "../AdminComponents/Header";
import { useDispatch, useSelector } from "react-redux";
import { ShowAllCoordinatorProfiles } from "../../../context/Slice/CoordinatorManagementSlice"; // Adjust the import path as needed
import "./AdminBookinManagement.css";
const BASE_URL = process.env.REACT_APP_BASE_URL; // Replace with your actual base URL

const BookingManagement = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const colors = tokens(theme.palette.mode);
  const [bookings, setBookings] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedCoordinator, setSelectedCoordinator] = useState(""); // State for the dropdown selection

  const coordinatorProfiles = useSelector(
    (state) => state.CoordinatorManagementR.Data || []
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(ShowAllCoordinatorProfiles()); // Dispatch the action to fetch coordinator profiles
  }, [dispatch]);

  // Log fetched data to console
  useEffect(() => {
    console.log("Fetched Coordinator Profiles: ", coordinatorProfiles);
  }, [coordinatorProfiles]);

  const nameOptions =coordinatorProfiles && coordinatorProfiles
    .map((profile) => {
      const { firstName, lastName } = profile.Coordinator || {};
      if (!firstName || !lastName) return null; // Handle missing names
      return `${firstName} ${lastName}`;
    })
    .filter(Boolean);

  // Fetch bookings from the API
  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const token = localStorage.getItem("token"); // Retrieve token from storage
        const response = await axios.get(
          `${BASE_URL}/api/v1/CoordinatorManagement/admin/Get-Event-Booking-Management`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("API Response: ", response.data); // Check the response structure
        console.log(
          "getAllEventBookingManagement: ",
          response.data.data.getAllEventBookingManagement
        ); // Check if the data exists
        setBookings(response.data.data.getAllEventBookingManagement || []);
      } catch (error) {
        console.error("Error fetching bookings:", error);
      }
    };

    fetchBookings();
  }, []);

  const handleViewClick = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  // Get unique event coordinators for the dropdown
  const eventCoordinators = [
    ...new Set(bookings.map((row) => row.eventCoordinator)),
  ];

  // Filter rows based on the selected event coordinator

  const columns = [
    {
      field: "eventCoordinator",
      headerName: "Event Coordinator Name",
      width: 190,
    },
    {
      field: "client_Name",
      headerName: "User Name",
      width: 120, // Fixed width
    },
    {
      field: "vendor_Name",
      headerName: "Vendor Name",
      width: 120, // Fixed width
    },
    {
      field: "event_Type",
      headerName: "Event Name",
      width: 120, // Fixed width
    },
    {
      field: "booking_Date",
      headerName: "Proposed Date",
      width: 120, // Fixed width
    },
    {
      field: "start_Date",
      headerName: "Start Date",
      width: 120, // Fixed width
    },
    {
      field: "end_Date",
      headerName: "End Date",
      width: 120, // Fixed width
    },
    {
      field: "booking_Details",
      headerName: "Booking Details",
      width: 120, // Fixed width
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleViewClick(params.row)}
        >
          View
        </Button>
      ),
    },
  ];

  const processedBookings = bookings.map((booking) => ({
    ...booking,
    eventCoordinator: `${booking.coordinator.firstName} ${booking.coordinator.lastName}`,
  }));

  const filteredRows = processedBookings.filter((row) =>
    selectedCoordinator ? row.eventCoordinator === selectedCoordinator : true
  );

  const HandleBack = () => {
    console.log("Back button clicked");
    navigate("/admin-dashboard");
  };
  console.log(bookings);

  return (
    <Box m="20px" id="AdminBookingManagement">
      <h2 className="Adminheading">Booking Management</h2>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "16px",
        }}
      >
        {/* Back Button */}

        <Button
          variant="contained"
          color="secondary"
          onClick={HandleBack}
          sx={{ position: "absolute", top: "20px", left: "20px" }}
        >
          Back
        </Button>
        {/* Dropdown to select Event Coordinator */}
        <FormControl
          variant="outlined"
          sx={{ minWidth: 200 }}
          className="DropDown "
        >
          <InputLabel className="DropDown-name">Event Coordinator</InputLabel>
          <Select
            value={selectedCoordinator}
            onChange={(e) => setSelectedCoordinator(e.target.value)}
            label="Event Coordinator"
            fullWidth
            className="text-sm sm:text-base"
          >
            <MenuItem value="">
              <em>All</em>
            </MenuItem>
            {nameOptions.map((coordinator) => (
              <MenuItem key={coordinator} value={coordinator}>
                {coordinator}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[900],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
        }}
      >
        <DataGrid
          rows={filteredRows} // Pass the filtered rows
          columns={columns}
          getRowId={(row) => row.id || row.eventCoordinator} // Adjust based on the data structure
          sx={{
            "& .MuiDataGrid-cell": {
              fontSize: {
                xs: "11px", // Smaller font for column headers on small screens
                sm: "12px",
                md: "14px",
              },
            },
            "& .MuiDataGrid-columnHeaders": {
              fontSize: {
                xs: "11px", // Smaller font for column headers on small screens
                sm: "12px",
                md: "14px",
              },
            },
            "& .MuiDataGrid-footerContainer": {
              fontSize: {
                xs: "11px", // Smaller font for column headers on small screens
                sm: "12px",
                md: "14px",
              },
            },
          }}
        />
      </Box>

      {/* Modal for Viewing Details */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
          }}
        >
          <Typography variant="h6" gutterBottom>
            Booking Details
          </Typography>
          {selectedRow && (
           <>
  <Typography variant="body1">
    <strong>Event Coordinator Name:</strong> {selectedRow.coordinator.firstName} {selectedRow.coordinator.lastName}
  </Typography>
  <Typography variant="body1">
    <strong>Coordinator Email:</strong> {selectedRow.coordinator.email}
  </Typography>
  <Typography variant="body1">
    <strong>Client Name:</strong> {selectedRow.client_Name}
  </Typography>
  <Typography variant="body1">
    <strong>Client Email:</strong> {selectedRow.client_Email}
  </Typography>
  <Typography variant="body1">
    <strong>Mobile No:</strong> {selectedRow.mobile_no}
  </Typography>
  <Typography variant="body1">
    <strong>Event Type:</strong> {selectedRow.event_Type}
  </Typography>
  <Typography variant="body1">
    <strong>Vendor Category:</strong> {selectedRow.vendor_Category}
  </Typography>
  <Typography variant="body1">
    <strong>Vendor Name:</strong> {selectedRow.vendor_Name}
  </Typography>
  <Typography variant="body1">
    <strong>Vendor Mobile:</strong> {selectedRow.vendor_Mobile}
  </Typography>
  <Typography variant="body1">
    <strong>Booking Date:</strong> {selectedRow.booking_Date}
  </Typography>
  <Typography variant="body1">
    <strong>Start Date:</strong> {selectedRow.start_Date}
  </Typography>
  <Typography variant="body1">
    <strong>End Date:</strong> {selectedRow.end_Date}
  </Typography>
  <Typography variant="body1">
    <strong>Guests:</strong> {selectedRow.guests}
  </Typography>
  <Typography variant="body1">
    <strong>Total Amount:</strong> {selectedRow.total_Amount}
  </Typography>
  <Typography variant="body1">
    <strong>Advance Paid:</strong> {selectedRow.advance_Paid}
  </Typography>
  <Typography variant="body1">
    <strong>Payment Method:</strong> {selectedRow.payment_method}
  </Typography>
  <Typography variant="body1">
    <strong>Payment Date:</strong> {selectedRow.payment_date}
  </Typography>
  <Typography variant="body1">
  <strong>Payment Screenshot:</strong>
  <br />
  {Array.isArray(selectedRow.upload_Payment_Screenshot) &&
  selectedRow.upload_Payment_Screenshot.length > 0 ? (
    selectedRow.upload_Payment_Screenshot.map((img, index) => {
      // Replace the specific directory path
      const cleanedPath = img.path.replace(
        "D:\\Hema Maam (free lancing project)\\Cosmic-Events\\CEP_BackEnd\\",
        ""
      );

      console.log("Original Path:", img.path);
      console.log("Cleaned Path:", `${BASE_URL}\\${cleanedPath}`);

      return (
        <img
          key={index}
          className="Serviceone-Images"
          src={`${BASE_URL}\\${cleanedPath}`}
          alt={`Payment Screenshot ${index + 1}`}
          style={{ maxWidth: "300px", height: "auto", marginTop: "8px" }}
        />
      );
    })
  ) : (
    <span>No screenshot available</span>
  )}
</Typography>




</>

          )}
          <Button
            variant="text" // Use the text variant for a normal button with no background
            onClick={() => setOpen(false)}
            sx={{
              mt: 2,
              color: "primary.main", // Keep the text color visible
              ml: "auto", // Push the button to the right
              display: "block", // Ensure it takes up space for positioning
              "&:hover": {
                backgroundColor: "transparent", // No background color on hover
                boxShadow: "none", // Remove the shadow on hover
              },
            }}
          >
            Close
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default BookingManagement;
